export const CONVO_STARTER_ID = 'convo-starter';
export const SUMMARIZE_CHANGES_ID = 'summarize-changes-ai-action';
export const DAILY_BRIEF_NUDGE_ID = 'daily-brief-nudge';
export const JIRA_BOARD_CATCH_UP_ID = 'jira-board-catch-up-rovo-nudge';
export const SIMILAR_WORK_ITEMS_ID = 'similar-work-items-nudge';
export const AUDIO_BRIEFING_ID = 'audio-briefing-ai-action';
export const AI_SPACE_CREATION_NUDGE_ID = 'ai-rovo.ai-space-creation-nudge';
export const INSIGHTS_NUDGE_ID = 'rovo-insights-nudge';
export const ACTION_ITEMS_NUDGE_ID = 'action-items-nudge-ai-action';
export const FOMO_NUDGE_ID = 'rovo-collab-teammates-fomo-nudge';
